import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="view-scroll"
export default class extends Controller {
  static targets = ["reportSection", "navCategory", "scrollContainer"];

  connect() {
    this.scrollContainerTarget.addEventListener(
      "scroll",
      this.checkVisibility.bind(this),
    );
    this.checkVisibility();
  }

  disconnect() {
    this.scrollContainerTarget.removeEventListener(
      "scroll",
      this.checkVisibility.bind(this),
    );
  }

  scroll(event) {
    const category = event.currentTarget.dataset.anchor;
    const section = this.reportSectionTargets.find(
      (section) => section.dataset.anchor === category,
    );

    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }

  checkVisibility() {
    const scrollTop = this.scrollContainerTarget.scrollTop;

    this.navCategoryTargets.forEach((nav, index) => {
      const targetId = nav.dataset.anchor;
      const section = this.reportSectionTargets.find(
        (section) => section.dataset.anchor === targetId,
      );

      if (section === undefined) {
        return;
      }

      const sectionTop = section.getBoundingClientRect().top + scrollTop;

      if (
        scrollTop + 155 >= sectionTop &&
        scrollTop + 155 < sectionTop + section.offsetHeight
      ) {
        nav.dataset.viewPresence = "true";
      } else {
        nav.dataset.viewPresence = "false";
      }
    });
  }
}
